/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

 function initAcc(elem, option) {
   document.addEventListener('click', function (e) {
     if (!e.target.matches('.accordionHeader')) return;
     else {
       if (!e.target.parentElement.classList.contains('active')) {
         if (option == true) {
           var elementList = elem.querySelectorAll('.accordionItem');
           Array.prototype.forEach.call(elementList, function (e) {
             e.classList.remove('active');
           });
         }
         e.target.parentElement.classList.add('active');
       } else {
         e.target.parentElement.classList.remove('active');
       }
     }
   });
 }

const documentAccordions = document.querySelectorAll('.accordion');
if (documentAccordions) {
  documentAccordions.forEach(function(el) {
    let triggers = el.querySelectorAll('.accordionHeader');
    triggers.forEach(function(trgr) {
      trgr.addEventListener('click', function(e) {
        let parentEl = trgr.parentElement;
        let siblingItems = el.querySelectorAll('.accordionItem');
        if (! parentEl.classList.contains('active')) {
          parentEl.classList.add('active');
          if (siblingItems) {
            siblingItems.forEach(function(sblng) {
              if (sblng !== parentEl) {
                sblng.classList.remove('active');
              }
            })
          }
        } else {
          parentEl.classList.remove('active');
        }
      })
    })
  })
}

var prodStatusAvailable = document.querySelector('.prodStatusAvailable');
var prodStatusSoldout = document.querySelector('.prodStatusSoldout');

document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant;
  if (prodStatusAvailable && prodStatusSoldout) {
    if (typeof variant !== 'undefined' && variant.available) {
      prodStatusAvailable.classList.remove('d-none');
      prodStatusSoldout.classList.add('d-none');
    } else {
      prodStatusAvailable.classList.add('d-none');
      prodStatusSoldout.classList.remove('d-none');
    }
  }

  const variantSpecific = document.querySelectorAll('.variantSpecific');
  if (variantSpecific) {
    variantSpecific.forEach(function(el) {
      if (el.dataset.variantId == variant.id) {
        el.classList.remove('d-none');
      } else {
        el.classList.add('d-none');
      }
    });
  }

  if (event.target.classList.contains('shopify-product-form')) {
    let id = event.target.getAttribute('id');
    let matchingQtyInput = document.querySelector(`input[name="quantity"][form="${id}"]`);
    if (matchingQtyInput) {
      let min = variant.quantity_rule.min || 1;
      let step = variant.quantity_rule.increment || 1;
      let max = variant.quantity_rule.max || null;
      matchingQtyInput.setAttribute('min', min);
      matchingQtyInput.setAttribute('step', step);
      if (max) {
        matchingQtyInput.setAttribute('max', max);
      } else {
        matchingQtyInput.removeAttribute('max');
      }
      matchingQtyInput.value = min;
    }
  }
});

const toggleButtonLink = document.querySelectorAll('.toggleButtonLink');
if (toggleButtonLink) {
  toggleButtonLink.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.stopPropagation();
    })
  })
}

async function customATCFormAdd(formData) {
  const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
    body: formData,
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  });

  return response;
}

// Deal of the month: when the deal product is added via its box, tag the cart
// with a merchant-defined attribute (configured in the Cart drawer section
// settings). The attribute shows on the order under "Additional details" and is
// what Shopify Flow reads to add the order tag. Optionally the same value is
// appended to the cart note (which becomes the order note), without overwriting
// a note the customer typed.
async function applyDealMonthCartMeta(btn) {
  const attrName = btn && btn.dataset.dealAttrName;
  const attrValue = btn && btn.dataset.dealAttrValue;
  if (!attrName || !attrValue) return;

  const payload = { attributes: {} };
  payload.attributes[attrName] = attrValue;

  const noteText = btn.dataset.dealNoteText;
  if (btn.dataset.dealAddNote === 'true' && noteText) {
    try {
      const cart = await (await fetch(`${window.themeVariables.routes.cartUrl}.js`)).json();
      const currentNote = cart.note || '';
      if (currentNote.indexOf(noteText) === -1) {
        payload.note = currentNote ? `${currentNote}\n${noteText}` : noteText;
      }
    } catch (err) {
      console.error('Deal of the month: could not read cart note', err);
    }
  }

  await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
}

// Delegated click handling so it also covers the deal-of-month form after the
// cart drawer re-renders (the box reappears when the deal product is removed
// from the cart). These classes are used only by the deal-of-month box.
document.addEventListener('click', function(e) {
  const atcBtn = e.target.closest('.customATCBtn');
  if (!atcBtn) return;
  const form = atcBtn.closest('.customATCForm');
  if (!form) return;

  e.preventDefault();
  atcBtn.innerHTML = atcBtn.dataset.loadingText;

  const formData = new FormData(form);
  customATCFormAdd(formData).then(async response => {
    if (response.ok) {
      await applyDealMonthCartMeta(atcBtn);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }
  });
});

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

function modifyDocAppsWidget() {
  let cartSummarySubtotalCost = document.querySelector('.docapp-cart-item.docapp-cart-subtotal .docapp-right .money');
  let cartSummaryTotalCost = document.querySelector('.docapp-cart-item.docapp-est-total .docapp-right .money');
  let cartSummaryShippingCost = document.querySelector('.docapp-cart-item.docapp-est-shipping-cost .docapp-right');
  let cartSummaryDiscountCost = document.querySelector('.docapp-cart-item.docapp-cart-discount .docapp-right .money');
  let currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  if (cartSummaryShippingCost) {
    cartSummaryShippingCost.innerHTML = `<strong class="text-uppercase">${window.themeVariables.strings.cartForFree}</strong>`;
  }
  alert
  if (cartSummarySubtotalCost && cartSummaryTotalCost) {
    let subtotalPrice = Number(cartSummarySubtotalCost.getAttribute('data-geolizr-price'));
    let discountPrice = cartSummaryDiscountCost ? Number(cartSummaryDiscountCost.getAttribute('data-geolizr-price')) : 0;
    cartSummaryTotalCost.innerHTML = formatMoney(subtotalPrice - discountPrice, currencyFormat);
  }
}

window['docappExcludedProductIDs'] = [8419700736267];
window['docappDisabledDiscountItemError'] = 'Dieser Kauf ist bereits rabattiert';
window['docappCartModifier'] = function(cartResponse) {
  let modifiedResponse = JSON.parse(JSON.stringify(cartResponse));
  window.modifiedResponse1 = modifiedResponse;
  modifiedResponse.items.forEach(function(cartItem) {
    if (cartItem.selling_plan_allocation?.selling_plan?.recurring_deliveries) {
      modifyDocAppsWidget();
    }
  })
  modifiedResponse.items = modifiedResponse.items.map(function(cartItem) {
    console.log(cartItem);
    if (!window['docappExcludedProductIDs'].includes(cartItem.product_id)) return cartItem;
    cartItem.disable_discounts = true;
    return cartItem;
  });
  return modifiedResponse;
};

document.body.addEventListener('docapp-widgets-updated', () => { 
  if (document.querySelector('[name="cartSubscriptionalProductDetector"]')) {
    modifyDocAppsWidget();
  }
});

const productForms = document.querySelectorAll('.product-buybox .product-form');
if (productForms) {
  productForms.forEach(function(form) {
    const subscriptionAdvantages = form.querySelector('.product-form__subscription-advantages.rechargeAdvantages');
    const productText = form.querySelector('.product-form__text');

    if (subscriptionAdvantages && productText) {
      subscriptionAdvantages.insertAdjacentElement('afterend', productText);
    }
  });
}

/**
 * The reviews.io rating snippet only scans the DOM when it is first executed, and the quick buy drawer/popover fetch
 * their content after that. They render their stars with a dedicated class so we can re-run the snippet for them
 * without touching (and re-rendering) the ones already on the page.
 *
 * "openable-element:load:end" does not bubble, so we listen during the capture phase.
 */
document.addEventListener('openable-element:load:end', function (event) {
  const target = event.target;

  if (!target.matches || !target.matches('quick-buy-drawer, quick-buy-popover')) {
    return;
  }

  if (!target.querySelector('.ruk_rating_snippet--quick-buy')) {
    return;
  }

  if (typeof ratingSnippet !== 'function' || !window.ratingSnippetConfig) {
    return;
  }

  ratingSnippet('ruk_rating_snippet--quick-buy', window.ratingSnippetConfig);
}, true);

/**
 * The mobile quick buy popover closes itself once a variant has been added and lets the mini cart take over. The
 * desktop quick buy drawer never got that behaviour: it stays open and falls back to its own cart notification,
 * whose "view cart" link points at the cart page instead of the drawer.
 *
 * Closing the drawer is only half of it. ProductForm suppresses the mini cart for every form sitting inside a
 * ".drawer", so we also have to put "openMiniCart" back. "cart:refresh" is dispatched on documentElement right
 * after "variant:added", and CartDrawer listens for it while it bubbles, so a capture listener on document gets
 * to the detail first.
 */
let quickBuyDrawerShouldOpenMiniCart = false;

document.addEventListener('variant:added', function (event) {
  const quickBuyDrawer = event.target.closest && event.target.closest('quick-buy-drawer');

  if (!quickBuyDrawer) {
    return;
  }

  quickBuyDrawerShouldOpenMiniCart = true;
  quickBuyDrawer.open = false;
});

document.addEventListener('cart:refresh', function (event) {
  if (!quickBuyDrawerShouldOpenMiniCart) {
    return;
  }

  quickBuyDrawerShouldOpenMiniCart = false;

  if (event.detail) {
    event.detail.openMiniCart = true;
  }
}, true);
